<template>
  <v-container fluid class="asset-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-asset`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Asset
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Items
          </v-tab>
          <v-tab
            v-show="initvalue.assettype=='List'"
            class="mr-5"
            :href="`#tab-lists`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Lists
          </v-tab>
          <v-tab
            v-show="initvalue.assettype=='Image'"
            class="mr-5"
            :href="`#tab-images`"
          >
            <v-icon class="mr-3">mdi-image-multiple</v-icon>
            Images
          </v-tab>
          <v-tab-item
            :value="'tab-asset'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Asset</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetcode')"
                        v-bind:value="initvalue.assetcode"
                        placeholder="Asset Code"
                        persistent-hint
                        single-line hint="Enter the asset code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetname')"
                        v-bind:value="initvalue.assetname"
                        placeholder="Asset Name"
                        persistent-hint
                        single-line hint="Enter the asset name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetpage')"
                        v-bind:value="initvalue.assetpage"
                        placeholder="Asset Page"
                        persistent-hint
                        single-line hint="Enter the asset page">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=assettype
                        :value="initvalue.assettype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assettype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the asset type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'assetstatus')"
                          v-bind:label="initvalue.assetstatus"
                          v-model="initvalue.assetstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/asset/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editAsset()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Items</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                            to="/asset/list"
                            replace
                            color="primary"
                          >
                            Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="itemrank"
                        :headers="header_items"
                        :items="assetitems"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.itemcode }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteAssetItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:src="item.itemimage"
                            max-height="50"
                            max-width="50"
                          ></v-img>
                        </template>  
                        <template v-slot:item.pageid="{ item }">
                          <p class="two-line" v-if="item.pageid!=undefined">{{ webpages.length>0 && webpages.find(group=>group._id == item.pageid) ? webpages.find(group=>group._id == item.pageid)['pagename'] || '' : ''  }}</p>
                        </template>
                        <template v-slot:item.containerid="{ item }">
                          <p class="two-line" v-if="item.containerid!=undefined">{{ webcontainers.length>0 ? webcontainers.find(x=>x._id == item.containerid)['containername'] : ''  }}</p>
                        </template>
                        <template v-slot:item.itemcode="{ item }">
                          <p class="two-line">{{ item.itemcode }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editAssetItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteAssetItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-lists'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Asset Lists</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showListDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_lists"
                        :items="assetlists"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteList" width="500">
                            <v-card>
                              <v-card-title> Delete this List? </v-card-title>
                              <v-card-text>
                                {{ delete_list.listtext }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteList = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteAssetList(delete_list)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editAssetListSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteAssetListDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/asset/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-images'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Asset Images</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showImageDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_images"
                        :items="assetimages"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteImageDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Image? </v-card-title>
                              <v-card-text>
                                {{ deleteimage.imagename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteImageDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteAssetImage(deleteimage)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.imagename="{ item }">
                          <p class="two-line"><strong>{{ item.imagename }}</strong></p>
                          <p class="two-line">{{ item.imageinfo  }}</p>
                        </template>
                        <template v-slot:item.imageurl="{ item }">
                            <img v-if="item.imageurl" v-bind:src="item.imageurl" alt="" width="80">
                        </template>                          
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editAssetImageSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteAssetImageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/asset/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isAddItem"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="add_item.itemrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Menu', 'Text', 'Image', 'Object']"
                    v-model="add_item.itemtype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" md="7">
                  <v-file-input dense label="File input" v-model="new_itemphoto" v-on:change="onChangeItemPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    dense
                    v-model="add_item.itemcode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    dense
                    v-model="add_item.itemname"
                    label="Name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    dense
                    v-model="add_item.iteminfo"
                    label="Info"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_item.itemdata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddItem=false; add_item={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addAssetItemRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditItem"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-on:change="onChangeItem($event, 'itemrank')"
                    :value="edit_item.itemrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select
                      dense
                      class="mb-4"
                      :items="['Menu', 'Text', 'Image', 'Object']"
                      v-on:change="onChangeItem($event, 'itemtype')"
                      :value="edit_item.itemtype"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                    >
                    </v-select>
                  </v-col>

                <v-col cols="12" md="7">
                  <v-file-input dense label="File input" v-model="edit_itemphoto" v-on:change="onChangeItemPhotoEdit" accept="image/*" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    dense
                    v-on:change="onChangeItem($event, 'itemcode')"
                    :value="edit_item.itemcode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                    <v-text-field
                      dense
                      v-on:change="onChangeItem($event, 'itemname')"
                      :value="edit_item.itemname"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      dense
                      v-on:change="onChangeItem($event, 'iteminfo')"
                      :value="edit_item.iteminfo"
                      label="Info"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-on:change="onChangeItem($event, 'itemdata')"
                      :value="edit_item.itemdata"
                      rows=5
                      label="Data"
                      required
                    ></v-textarea>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditItem=false; edit_item={};"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editAssetItemRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


    <v-row justify="center">
    <v-dialog
      v-model="showListDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_list.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_list.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_list.listvalue"
                  label="Value"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_list.textinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showListDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addAssetList"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showImageDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="image.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="image.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input outlined dense label="File input" v-on:change="onImageFileChange" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  outlined
                  dense
                  v-model="image.imageinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showImageDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addAssetImage"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
      <v-bottom-sheet scrollable v-model="showListSheet" inset>
        <v-sheet class="text-center" height="250px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showListSheet = !showListSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listrank')"
                  :value="edit_list.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listtext')"
                  v-model="edit_list.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listvalue')"
                  v-model="edit_list.listvalue"
                  label="Value"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedList($event, 'textinfo')"
                  v-model="edit_list.textinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAssetList()"
          >
            Edit
          </v-btn>
              </v-col>
          </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet scrollable v-model="showImageSheet" inset>
        <v-sheet class="text-center" height="350px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showImageSheet = !showImageSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagerank')"
                  :value="editimage.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagename')"
                  :value="editimage.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-file-input outlined dense label="File input" v-model="imagefile" v-on:change="onImageFileChange" accept="image/*" />     
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                dense
                v-on:change="updateChangedImage($event, 'imageinfo')"
                :value="editimage.imageinfo"
                label="Info"
                required
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAssetImage()"
          >
            Edit
          </v-btn>
              </v-col>
           </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_items: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Image", value: "itemimage", width: "10%" }, 
        { text: "Type", value: "itemtype", width: "10%" },
        { text: "Code", value: "itemcode", width: "12%"  },
        { text: "Name", value: "itemname" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_images: [
        { text: "#", value: "imagerank", width: "10px" },
        { text: "Image", value: "imageurl", width: "10%"},
        { text: "Name", value: "imagename" , width: "65%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_lists: [
        { text: "#", value: "listrank", width: "10px" },
        { text: "Text", value: "listtext" },
        { text: "Value", value: "listvalue" },
        { text: "Info", value: "textinfo" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      asset: {},
      assetitems: [],
      assetlists: [],
      assetimages: [],
      assettype: ['Image', 'List', 'Video'],

      add_list: {},
      add_item: {},
      edit_list: {},
      edit_item: {},
      delete_list: {},
      delete_item: {},
      change_item: {},
      editimage: {},
      deleteimage: {},
      isAddItem: false,
      isEditItem: false,
      isDeleteItem: false,
      isDeleteList: false,
      showListDialog: false,
      showListSheet: false,
      image: {},
      new_itemphoto: null,
      edit_itemphoto: null,
      imagefile: null,

      deleteImageDialog: false,
      showImageDialog: false,
      showImageSheet: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('Asset', [
      'getAssetsRequest',
      'deleteAssetItemRequest', 'deleteAssetImageRequest', 'deleteAssetListRequest',
      'insertAssetItemRequest', 'insertAssetItemWithImageRequest','insertAssetListRequest', 'insertAssetImageRequest',
      'updateAssetRequest','updateAssetItemRequest','updateAssetListRequest','updateAssetImageRequest',
    ]),
    async addAssetItemRequest() {
      this.isAddItem = false;
      this.add_item.assetid = this.initvalue._id;
      let result;
      if(this.add_item.imagefile!=undefined && this.add_item.imagefile!=null) result = await this.insertAssetItemWithImageRequest(this.add_item);
      else result = await this.insertAssetItemRequest(this.add_item);
      this.assetitems.push(result);
      this.add_item = {};
    },
    async addAssetList() {
      this.showListDialog = false;
      this.add_list.assetid = this.initvalue._id;
      let result = await this.insertAssetListRequest(this.add_list);
      this.assetlists.push(result);
      this.add_list = {};
    },
    async addAssetImage() {
      this.showImageDialog = false;
      this.image.assetid = this.initvalue._id;
      let result = await this.insertAssetImageRequest(this.image);
      this.assetimages.push(result);
      this.image = {};
    },
    deleteAssetItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = { _id: item._id, itemcode: item.itemcode };
    },
    deleteAssetListDialog(item) {
      this.isDeleteList = true;
      this.delete_list = {
        _id: item._id,
        listtext: item.listtext,
      };
    },
    deleteAssetImageDialog(item) {
      this.deleteImageDialog = true;
      this.deleteimage = {
        _id: item._id,
        imagename: item.imagename,
      };
    },
    async deleteAssetItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteAssetItemRequest(payload);
      let index = this.assetitems.findIndex(i=>i._id==response._id);
      this.assetitems.splice(index, 1);
    },
    async deleteAssetList(payload) {
      this.isDeleteList = false;
      let response = await this.deleteAssetListRequest(payload);
      let index = this.assetlists.findIndex((trans) => trans._id == response._id);
      this.assetlists.splice(index, 1);
    },
    async deleteAssetImage(payload) {
      this.deleteImageDialog = false;
      let response = await this.deleteAssetImageRequest(payload);
      let index = this.assetimages.findIndex((trans) => trans._id == response._id);
      this.assetimages.splice(index, 1);
    },
    editAsset() {
      this.asset._id = this.initvalue._id;
      this.updateAssetRequest(this.asset);
      this.getAssetsRequest();
      router.push('/asset/list');
    },
    async editAssetList() {
      this.showListSheet = false;
      this.add_list.assetlistid = this.edit_list._id;
      let response = await this.updateAssetListRequest(this.add_list);
      let index = this.assetlists.findIndex((x) => x._id == response._id);
      this.assetlists.splice(index, 1, response);
    },
    async editAssetItemRequest() {
      this.isEditItem = false;
      this.change_item._id = this.edit_item._id;
      let result;
      if(this.change_item.imagefile!=null) result = await this.updateAssetItemWithImageRequest(this.change_item);
      else result = await this.updateAssetItemRequest(this.change_item);
      let index = this.assetitems.findIndex((x) => x._id == result._id);
      this.assetitems.splice(index, 1, result);
      this.edit_item = {};
      this.change_item = {};
    }, 
    editAssetItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    editAssetListSheet(item) {
      this.add_list = {};
      this.showListSheet = true;
      this.edit_list = Object.assign({}, item);
    },
    editAssetImageSheet(item) {
      this.image = {};
      this.showImageSheet = true;
      this.editimage = Object.assign({}, item);
    },
    async editAssetImage() {
      this.showImageSheet = false;
      this.imagefile = null;
      this.image.assetimageid = this.editimage._id;
      let response = await this.updateAssetImageRequest(this.image);
      let index = this.assetimages.findIndex((x) => x._id == response._id);
      this.assetimages.splice(index, 1, response);
    },
    onImageFileChange(file) {
      if (!file) {return;}
      this.image.imagefile = file;
      this.image.imagefilename = file.name;
    },
    updateChangedValue(value, field){
      this.asset[field] = value;
    },
    updateChangedImage(value, field){
      this.image[field] = value;
    }, 
    updateChangedList(value, field){
      this.change_list[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },  
    onChangeItemPhoto(file) {
      if (!file) return;
      this.add_item.imagefile = file;
      this.add_item.imagename = file.name;
      console.log(this.add_item)
    },
    onChangeItemPhotoEdit(file) {
      if (!file) return;
      this.change_item.imagefile = file;
      this.change_item.imagename = file.name;
      console.log(this.add_item)
    },      
  },
  computed: {
    ...mapState('Asset', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.assetitems = this.initvalue.assetitems;
    this.assetlists = this.initvalue.assetlists;
    this.assetimages = this.initvalue.assetimages;
    if(!this.initvalue._id) this.$router.push({ name: 'AssetList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
